import { render, staticRenderFns } from "./recycleBinProduct.vue?vue&type=template&id=1df3ec10&scoped=true"
import script from "./recycleBinProduct.vue?vue&type=script&lang=js"
export * from "./recycleBinProduct.vue?vue&type=script&lang=js"
import style0 from "./recycleBinProduct.vue?vue&type=style&index=0&id=1df3ec10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3ec10",
  null
  
)

export default component.exports